// extracted by mini-css-extract-plugin
module.exports = {"container":"userSales_container__bKrIU","image":"userSales_image__1elbH","button":"userSales_button__5wDF1","button2":"userSales_button2__GSIER"};